import { createContext, useContext, useEffect, useState } from 'react'
import { prettyLog } from '../../utils'

// context/ExternalPathsContext.tsx
const ExternalPathsContext = createContext<string[]>(['/Services/'])

export const ExternalPathsProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [paths, setPaths] = useState(['/Services/', '/votes'])

  useEffect(() => {
    fetch('/config/external-paths.json')
      .then(r => r.json())
      .then(data => setPaths(data.hardReloadPaths))
      .catch(e => prettyLog('ExternalPathsProvider: 16', { e }, 'error'))
  }, [])

  return (
    <ExternalPathsContext.Provider value={paths}>
      {children}
    </ExternalPathsContext.Provider>
  )
}

export const useExternalPaths = () => useContext(ExternalPathsContext)
